import { store } from '@/store';
const MainHeader = () => import('@/components/MainHeader');
const CarCarForm = () => import('@/views/car/calculator/CarForm');
const MotorCarForm = () => import('@/views/motor/calculator/CarForm');
const Regulations = () => import('@/views/common/calculator/Regulations');
const CarAssuredForm = () => import('@/views/car/calculator/AssuredForm');
const MotorAssuredForm = () => import('@/views/motor/calculator/AssuredForm');
const Preview = () => import('@/views/common/calculator/Preview');
const Refusal = () => import('@/views/common/calculator/Refusal');
const Contact = () => import('@/views/common/calculator/Contact.vue');
const CarCustomization = () => import('@/views/car/calculator/Customization');
const MotorCustomization = () => import('@/views/motor/calculator/Customization');

/**
 * 保費試算流程
 */
export default [
    {
        // step-1 同意條款
        path: '/:type(car|motor)/calculator',
        name: 'CarCalculator',
        components: {
            default: Regulations,
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {
            // if (!store.getters['auth/loggedIn']) {
            //     store.commit('nav/setAll', {to: to, from: from, clear: true});
            //     return next({name: 'Login' });
            // }
            
            next();
        }
    },
    {
        // step-2 被保險人資料表單
        path: '/:type(car|motor)/calculator/assured-form',
        name: 'CalculatorAssuredForm',
        components: {
            default: '',
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {
            if (to.params.type === 'car') {
                to.matched[0].components.default = CarAssuredForm;
            } else if (to.params.type === 'motor') {
                to.matched[0].components.default = MotorAssuredForm;
            }
            next();
        }
    },
    {
        // step-3 車籍資料表單
        path: '/:type(car|motor)/calculator/car-form',
        name: 'CalculatorCarForm',
        components: {
            default: '',
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {
            if (to.params.type === 'car') {
                to.matched[0].components.default = CarCarForm;
            } else if (to.params.type === 'motor') {
                to.matched[0].components.default = MotorCarForm;
            }

            // 如果還沒填入被保險人ID，退回上一頁
            if (!store.state.estimate.AssuredId) {
                return next(`/${to.params.type}/calculator/assured-form`);
            }

            next();
        }
    },
    {
        // step-4 商品選擇頁
        path: '/:type(car|motor)/calculator/customization',
        name: 'CalculatorCustomization',
        components: {
            default: '',
            header: MainHeader
        },
        beforeEnter: (to, from, next) => {
            if (to.params.type === 'car') {
                to.matched[0].components.default = CarCustomization;
            } else if (to.params.type === 'motor') {
                to.matched[0].components.default = MotorCustomization;
            }

            // 微電車除外，如果無車籍資料，退回上一頁 (CarType35微電車無廠牌)
            if (store.state.estimate.CarType !== '35' && !store.state.estimate.BrandId) {
                return next(`/${to.params.type}/calculator/car-form`);
            }

            next();
        }
    },
    {
        // step-5 試算結果
        path: '/:type(car|motor)/calculator/preview',
        name: 'CarCalculatorPreview',
        components: {
            default: Preview,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            // 如果還沒取得試算結果，退回上一步
            if (!store.state.policy.calculatedAt) {
                return next(`/${to.params.type}/calculator/customization`);
            }

            next();
        }
    },
    {
        // 保費試算錯誤
        path: '/:type(car|motor)/calculator/refusal',
        name: 'CarCalculatorRefusal',
        components: {
            default: Refusal,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            // 如果還沒設定入口，退回首頁
            if (!store.state.policy.entry) {
                return next(`/${to.params.type}`);
            }

            next();
        }
    },
    /**
     * 聯絡件資料填寫頁面
     */
    {
        path: '/:type(car|motor)/calculator/contact',
        name: 'CarContactForm',
        components: {
            default: Contact,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (!store.state.estimate.AssuredId) {
                return next(`/${to.params.type}`);
            }

            next();
        }
    }
];